class CookieBuilder extends HTMLElement {
  async connectedCallback() {
    this.core = await import(this.dataset.coreUrl);
    this.config = JSON.parse(this.querySelector('[data-config]').textContent);
    this.gifting = this.config.mode === 'gifting';
    const checked = this.querySelector('[data-size]:checked');
    this.state = {
      size: this.config.sizes.find((s) => String(s.id) === checked?.value) || this.config.sizes.find((s) => s.available) || this.config.sizes[0],
      picks: [],
      pickMode: this.gifting ? 'assorted' : 'custom',
      date: null,
      sendTo: 'one',
      addresses: [],
    };
    this.busy = false;
    this.addEventListener('click', (event) => this.onClick(event));
    this.addEventListener('change', (event) => this.onChange(event));
    this.addEventListener('input', (event) => this.onInput(event));
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        this.busy = false;
        this.render();
      }
    });
    if (this.gifting) this.renderDates();
    this.render();
  }

  boxes() {
    return Math.floor(this.state.size.size / 6);
  }

  sizeLabel() {
    const { size } = this.state.size;
    return this.gifting ? `${size} Cookies (${this.boxes()} boxes of 6)` : `${size} Cookies`;
  }

  needsPicks() {
    return !this.gifting || this.state.pickMode === 'custom';
  }

  selectedCard() {
    const input = this.querySelector('[data-gift-options] input[type="radio"]:checked');
    return input && input.value ? input : null;
  }

  onClick(event) {
    const { core, state } = this;
    const row = event.target.closest('[data-flavour]');
    if (event.target.closest('[data-add]') && row) state.picks = core.addPick(state.picks, row.dataset.flavour, state.size.size);
    else if (event.target.closest('[data-remove]') && row) state.picks = core.removePick(state.picks, row.dataset.flavour);
    else if (event.target.closest('[data-slot]')) state.picks = core.removeAt(state.picks, Number(event.target.closest('[data-slot]').dataset.slot));
    else if (event.target.closest('[data-photo]')) return this.openPhoto(event.target.closest('[data-photo]'));
    else if (event.target.closest('[data-close]')) return this.querySelector('[data-dialog]').close();
    else if (event.target.closest('[data-submit]')) return this.submit();
    else return;
    this.render();
  }

  onChange(event) {
    const { core, state } = this;
    const input = event.target;
    if (input.matches('[data-size]')) {
      state.size = this.config.sizes.find((s) => String(s.id) === input.value);
      state.picks = core.resize(state.picks, state.size.size);
      if (state.sendTo === 'many') this.setAddresses();
    } else if (input.matches('[data-pick-mode]')) {
      state.pickMode = input.value;
      if (input.value === 'assorted') state.picks = [];
    } else if (input.matches('[data-send-to]')) {
      state.sendTo = input.value;
      this.setAddresses();
    } else if (input.matches('[data-date]')) {
      state.date = input.value;
    }
    this.render();
  }

  onInput(event) {
    if (event.target.matches('[data-address]')) {
      this.state.addresses[Number(event.target.dataset.address)] = event.target.value;
      this.render();
    }
  }

  setAddresses() {
    const count = this.state.sendTo === 'many' ? this.boxes() : 0;
    this.state.addresses = Array.from({ length: count }, (_, i) => this.state.addresses[i] || '');
    const wrap = this.querySelector('[data-addresses]');
    wrap.replaceChildren(...this.state.addresses.map((value, i) => {
      const label = document.createElement('label');
      label.className = 'cb-address';
      label.textContent = `Box ${i + 1} delivery address`;
      const area = document.createElement('textarea');
      area.rows = 3;
      area.required = true;
      area.value = value;
      area.dataset.address = i;
      label.append(area);
      return label;
    }));
  }

  renderDates() {
    const { core } = this;
    const g = this.config.gifting;
    const dates = core.deliveryDates({
      now: new Date(), cutoffHour: g.cutoffHour, leadDays: g.leadDays,
      days: core.parseDays(g.days), blocked: core.parseDates(g.blocked), count: g.count,
    });
    const wrap = this.querySelector('[data-dates]');
    if (!dates.length) {
      wrap.textContent = 'No delivery dates are open right now. Please contact us to order.';
      return;
    }
    const fmt = (iso, part) => new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', [part]: part === 'day' ? 'numeric' : 'short' }).format(new Date(`${iso}T12:00:00Z`));
    wrap.replaceChildren(...dates.map((iso) => {
      const label = document.createElement('label');
      label.className = 'cb-date';
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `cb-date-${this.dataset.section}`;
      input.value = iso;
      input.dataset.date = '';
      const weekday = document.createElement('span');
      weekday.textContent = fmt(iso, 'weekday');
      const day = document.createElement('strong');
      day.textContent = fmt(iso, 'day');
      const month = document.createElement('span');
      month.textContent = fmt(iso, 'month');
      label.append(input, weekday, day, month);
      return label;
    }));
  }

  renderPicture() {
    const { config, state } = this;
    const size = state.size.size;
    if (this.gifting) {
      const boxes = this.boxes();
      const full = this.needsPicks() ? Math.floor(state.picks.length / 6) : boxes;
      this.querySelector('[data-minis]').replaceChildren(...Array.from({ length: boxes }, (_, i) => {
        const mini = document.createElement('span');
        mini.className = i < full ? 'cb-mini cb-mini--full' : 'cb-mini';
        mini.textContent = '6';
        return mini;
      }));
      return;
    }
    const slots = this.querySelector('[data-slots]');
    slots.style.setProperty('--cols', size <= 6 ? 3 : 6);
    slots.replaceChildren(...Array.from({ length: size }, (_, i) => {
      const id = state.picks[i];
      if (!id) {
        const empty = document.createElement('span');
        empty.className = 'cb-slot';
        return empty;
      }
      const flavour = config.flavours[id];
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cb-slot cb-slot--full';
      button.dataset.slot = i;
      button.setAttribute('aria-label', `Take out one ${flavour.name}`);
      if (flavour.image) {
        const img = document.createElement('img');
        img.src = flavour.image;
        img.alt = '';
        button.append(img);
      } else {
        button.textContent = flavour.name.charAt(0);
      }
      return button;
    }));
  }

  renderSummary(total, specials, card, deliveryQty) {
    const { core, config, state } = this;
    const lines = [[this.sizeLabel(), core.formatMoney(state.size.price)]];
    if (specials) lines.push([`${specials} × monthly special`, `+${core.formatMoney(specials * config.specialPrice)}`]);
    if (card) lines.push([`Card · ${card.dataset.title}`, `+${core.formatMoney(Number(card.dataset.price))}`]);
    if (this.gifting) lines.push([`Delivery · ${deliveryQty} address${deliveryQty > 1 ? 'es' : ''}`, `+${core.formatMoney(config.deliveryPrice * deliveryQty)}`]);
    lines.push(['Total', core.formatMoney(total)]);
    this.querySelector('[data-summary]').replaceChildren(...lines.map(([label, value], i) => {
      const row = document.createElement('div');
      if (i === lines.length - 1) row.className = 'cb-total';
      const dt = document.createElement('dt');
      dt.textContent = label;
      const dd = document.createElement('dd');
      dd.textContent = value;
      row.append(dt, dd);
      return row;
    }));
  }

  render() {
    const { core, config, state } = this;
    const size = state.size.size;
    const needsPicks = this.needsPicks();
    const counts = core.countPicks(state.picks);
    const full = state.picks.length >= size;

    for (const row of this.querySelectorAll('[data-flavour]')) {
      const count = counts[row.dataset.flavour] || 0;
      row.querySelector('[data-count]').textContent = count;
      row.toggleAttribute('data-picked', count > 0);
      row.querySelector('[data-remove]').disabled = count === 0;
      row.querySelector('[data-add]').disabled = full;
    }
    const list = this.querySelector('[data-flavour-list]');
    if (list) list.hidden = !needsPicks;
    for (const el of this.querySelectorAll('[data-progress]')) el.textContent = needsPicks ? `${state.picks.length} / ${size}` : '';
    this.querySelector('[data-live]').textContent = needsPicks ? `${state.picks.length} of ${size} cookies picked` : '';

    this.renderPicture();

    const card = this.selectedCard();
    const deliveryQty = this.gifting ? Math.max(1, state.addresses.length) : 0;
    const { specials, total } = core.totals({
      boxPrice: state.size.price, picks: state.picks, flavours: config.flavours, specialPrice: config.specialPrice,
      cardPrice: card ? Number(card.dataset.price) : 0, deliveryPrice: config.deliveryPrice, deliveryQty,
    });
    this.renderSummary(total, specials, card, deliveryQty);

    const cta = core.ctaState({
      size, picked: state.picks.length, needsPicks, gifting: this.gifting,
      date: state.date, sendTo: state.sendTo, addresses: state.addresses, total,
    });
    const button = this.querySelector('[data-submit]');
    button.textContent = this.busy ? 'Adding…' : cta.text;
    button.disabled = cta.disabled || this.busy || (this.gifting && !config.deliveryVariantId);
  }

  openPhoto(button) {
    const dialog = this.querySelector('[data-dialog]');
    dialog.querySelector('[data-dialog-img]').src = button.dataset.full;
    dialog.showModal();
  }

  async submit() {
    const { core, config, state } = this;
    const error = this.querySelector('[data-error]');
    error.hidden = true;
    this.busy = true;
    this.render();
    try {
      const card = this.selectedCard();
      const items = core.buildCartItems({
        variantId: state.size.id,
        sizeLabel: this.sizeLabel(),
        picks: this.needsPicks() ? state.picks : [],
        flavours: config.flavours,
        message: this.querySelector('[data-gift-message]')?.value || '',
        specialVariantId: config.specialVariantId,
        cardVariantId: card ? Number(card.value) : null,
        gifting: this.gifting ? { date: state.date, addresses: state.sendTo === 'many' ? state.addresses : [], deliveryVariantId: config.deliveryVariantId } : null,
        boxId: core.makeBoxId(window.crypto),
      });
      const response = await fetch(config.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || 'Something went wrong. Please try again.');
      }
      window.location.href = config.cartUrl;
    } catch (err) {
      error.textContent = err.message || 'Something went wrong. Please try again.';
      error.hidden = false;
      this.busy = false;
      this.render();
      error.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }
}

customElements.define('cookie-builder', CookieBuilder);
